import React from "react";
import { Box, SxProps, Typography } from "@mui/material";
import { TabSwitchStyles } from "./TabSwitchStyles";
import { TAB1, TAB2 } from "../../constants";
import { Theme } from "@emotion/react";

interface TabSwitchProps {
  tab1Title: string;
  tab2Title: string;
  tab1ActiveImage?: string;
  tab1InActiveImage?: string;
  tab2ActiveImage?: string;
  tab2InActiveImage?: string;
  handleTabClick: (tab: string) => void;
  activeTab?: string;
  isSlide?: boolean;
  tab1AdditionalStyles?: SxProps<Theme>;
  tab2AdditionalStyles?: SxProps<Theme>;
}
const TabSwitch: React.FC<TabSwitchProps> = ({
  handleTabClick,
  tab1Title,
  tab1ActiveImage,
  tab1InActiveImage,
  tab2ActiveImage,
  tab2InActiveImage,
  tab2Title,
  activeTab,
  isSlide,
  tab1AdditionalStyles,
  tab2AdditionalStyles,
}) => {
  return (
    <Box sx={TabSwitchStyles.container}>
      <Box sx={TabSwitchStyles.tabInnerContainer}>
        <Box sx={TabSwitchStyles.innerContainer}>
          <Box
            sx={{
              ...TabSwitchStyles.tabSwitchContainer,
              left: isSlide ? "50%" : 0,
            }}
          />
          <Box sx={TabSwitchStyles.tabSwitchInnerContainer}>
            <Box
              onClick={() => handleTabClick("tab1")}
              sx={Object.assign(
                {},
                TabSwitchStyles.tab1Styles,
                tab1AdditionalStyles
              )}
              id={`${tab1Title}-tab`}
              data-test-id={`${tab1Title}-tab`}
              role="tab"
              aria-selected={activeTab === `${TAB1}`}
              aria-label={`${tab1Title} tab`}
              tabIndex={0}
            >
              {tab1ActiveImage && (
                <img
                  src={
                    activeTab === `${TAB1}`
                      ? tab1ActiveImage
                      : tab1InActiveImage
                  }
                  alt={TAB1}
                  data-test-id={`${tab1Title}-tab-image`}
                />
              )}

              <Typography
                sx={{
                  zIndex: 3,
                  ...TabSwitchStyles.tab1TextStyles,
                  color:
                    activeTab === `${TAB1}`
                      ? "var(--white)"
                      : "var(--support-white)",
                }}
                data-test-id={`${tab1Title}-tab-text`}
              >
                {tab1Title}
              </Typography>
            </Box>
            <Box
              sx={Object.assign(
                {},
                TabSwitchStyles.tab2Styles,
                tab2AdditionalStyles
              )}
              onClick={() => handleTabClick("tab2")}
              id={`${tab2Title}-tab`}
              data-test-id={`${tab2Title}-tab`}
              role="tab"
              aria-selected={activeTab === `${TAB2}`}
              aria-label={`${tab2Title} tab`}
              tabIndex={0}
            >
              {tab2ActiveImage && (
                <img
                  src={
                    activeTab === `${TAB2}`
                      ? tab2ActiveImage
                      : tab2InActiveImage
                  }
                  alt={`${tab2Title} icon`}
                  data-test-id={`${tab2Title}-tab-image`}
                />
              )}

              <Typography
                sx={{
                  zIndex: 3,
                  ...TabSwitchStyles.tab2TextStyles,
                  color:
                    activeTab === `${TAB2}`
                      ? "var(--white)"
                      : "var(--support-white)",
                }}
                data-test-id={`${tab2Title}-tab-text`}
              >
                {tab2Title}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TabSwitch;
